import { DefaultChatTransport } from "ai";

import type { AdminAiChatInput } from "@upclaim/sdk/src/data-contracts";

import { config } from "@/lib/config";
import { getAuthToken } from "@/services/api/auth-token";

/** Les trois personas de l'assistant, tels que la route les valide. */
export type AssistantPersona = NonNullable<AdminAiChatInput["persona"]>;

/**
 * AI SDK transport to POST /admin/ai/chat — the single entry point, whether the
 * question is about one claim or the whole portfolio.
 *
 * A single token: the usual admin JWT. The API reaches the MCP reporting server
 * with its own Auth0 machine identity, so the browser no longer has to run an
 * OAuth dance of its own (see services/ai/mcp-machine-token.ts).
 *
 * `claimId` is the claim open in the UI: a starting point for the assistant,
 * not a scope — the API revalidates it under the caller's tenant.
 */
export function createAdminChatTransport(claimId?: string, persona?: AssistantPersona) {
  const body = { ...(claimId ? { claimId } : {}), ...(persona ? { persona } : {}) };

  return new DefaultChatTransport({
    api: `${config.API_URL}/admin/ai/chat`,
    headers: async (): Promise<Record<string, string>> => {
      const authToken = await getAuthToken();
      return authToken ? { Authorization: `Bearer ${authToken}` } : {};
    },
    body: Object.keys(body).length > 0 ? body : undefined,
  });
}
